export default {
  'pages.workspace.list.title': '工作區管理',
  'pages.workspace.list.subTitle': '管理專案下的程式碼工作區與邊界',
  'pages.codebase.catalog.title': '程式碼倉庫',
  'pages.codebase.catalog.subTitle': '管理專案下的程式碼倉庫與工作區歸屬',
  'pages.customerIntelligence.customerList.boolean.yes': '是',
  'pages.customerIntelligence.customerList.boolean.no': '否',
  'pages.customerIntelligence.customerList.placeholder.empty': '-',
  'pages.customerIntelligence.customerList.columns.name': '客戶名稱',
  'pages.customerIntelligence.customerList.columns.owner': '負責人',
  'pages.customerIntelligence.customerList.columns.mobile': '手機號',
  'pages.customerIntelligence.customerList.columns.email': '電子郵箱',
  'pages.customerIntelligence.customerList.columns.followUpStatus': '跟進狀態',
  'pages.customerIntelligence.customerList.columns.lockStatus': '鎖定',
  'pages.customerIntelligence.customerList.columns.dealStatus': '成交',
  'pages.customerIntelligence.customerList.columns.contactLastTime':
    '最近聯繫時間',
  'pages.customerIntelligence.customerList.columns.contactNextTime':
    '下次聯繫時間',
  'pages.customerIntelligence.customerList.search.keyword': '關鍵詞',
  'pages.customerIntelligence.customerList.alert.missingMember':
    '當前帳號未綁定成員資訊，暫無法查看或新增客戶。',
  'pages.customerIntelligence.customerList.alert.missingTenant':
    '當前未選擇租戶，客戶資料可能無法正常載入。',
  'pages.customerIntelligence.customerList.create.button': '新增客戶',
  'pages.customerIntelligence.customerList.create.success': '客戶建立成功',
  'pages.customerIntelligence.customerList.create.error': '新增客戶失敗',
  'pages.customerIntelligence.customerList.create.modalTitle': '新增客戶',
  'pages.customerIntelligence.customerList.create.form.name': '客戶名稱',
  'pages.customerIntelligence.customerList.create.form.name.required':
    '請輸入客戶名稱',
  'pages.customerIntelligence.customerList.create.form.name.placeholder':
    '請輸入客戶名稱',
  'pages.customerIntelligence.customerList.create.form.mobile': '手機號',
  'pages.customerIntelligence.customerList.create.form.telephone': '固定電話',
  'pages.customerIntelligence.customerList.create.form.email': '電子郵箱',
  'pages.customerIntelligence.customerList.create.form.qq': 'QQ',
  'pages.customerIntelligence.customerList.create.form.wechat': '微信',
  'pages.customerIntelligence.customerList.create.form.remark': '備註',
  'pages.customerIntelligence.customerList.empty': '暫無客戶資料',
  'pages.customerIntelligence.customerList.detail.title': '客戶詳情',
  'pages.layouts.userLayout.title': '你好！',
  'pages.getCaptchaSecondText': '秒後重新獲取',
  'pages.workbench.link': '歡迎使用',
  'pages.workbench.alertMessage': '更快更強的重型組件，已經發布。',
  'pages.404.subTitle': '抱歉，您訪問的頁面不存在。',
  'pages.404.buttonText': '返回首頁',
  'pages.admin.subPage.title': '這個頁面只有 admin 權限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 現已發佈，歡迎使用 npm run ui 啓動體驗。',
  'pages.searchTable.createForm.newRule': '新建規則',
  'pages.searchTable.updateForm.ruleConfig': '規則配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '規則名稱',
  'pages.searchTable.updateForm.ruleName.nameRules': '請輸入規則名稱！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '規則描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '請輸入至少五個字符',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '請輸入至少五個字符的規則描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置規則屬性',
  'pages.searchTable.updateForm.object': '監控對象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '規則模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '規則類型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '設定調度週期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '請選擇開始時間！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '規則名稱爲必填項',
  'pages.searchTable.titleCallNo': '服務調用次數',
  'pages.searchTable.titleStatus': '狀態',
  'pages.searchTable.nameStatus.default': '關閉',
  'pages.searchTable.nameStatus.running': '運行中',
  'pages.searchTable.nameStatus.online': '已上線',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '上次調度時間',
  'pages.searchTable.exception': '請輸入異常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '訂閱警報',
  'pages.searchTable.title': '查詢表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已選擇',
  'pages.searchTable.item': '項',
  'pages.searchTable.totalServiceCalls': '服務調用次數總計',
  'pages.searchTable.tenThousand': '萬',
  'pages.searchTable.batchDeletion': '批量刪除',
  'pages.searchTable.batchApproval': '批量審批',
  'pages.template.title': '模板示例',
  'pages.template.submit.success': '表單提交成功！',
  'pages.template.form.name': '姓名',
  'pages.template.form.email': '電子郵箱',
  'pages.template.form.department': '部門',
  'pages.template.form.joinDate': '入職日期',
  'pages.template.form.remarks': '備註',
  'pages.template.placeholder.name': '請輸入姓名',
  'pages.template.placeholder.email': '請輸入電子郵箱',
  'pages.template.placeholder.department': '請選擇部門',
  'pages.template.placeholder.remarks': '請輸入備註資訊',
  'pages.template.validation.nameRequired': '請輸入姓名',
  'pages.template.validation.emailRequired': '請輸入電子郵箱',
  'pages.template.validation.emailInvalid': '電子郵箱格式不正確',
  'pages.template.validation.departmentRequired': '請選擇部門',
  'pages.template.validation.joinDateRequired': '請選擇入職日期',
  'pages.template.department.tech': '技術部',
  'pages.template.department.sales': '銷售部',
  'pages.template.department.hr': '人力資源部',
  'pages.template.department.finance': '財務部',
  'pages.template.action.submit': '提交',
  'pages.template.action.reset': '重置',
  'pages.defectManagement.title': '缺陷管理',
  'pages.defectManagement.subTitle': '缺陷提報、分派、修復驗證與關閉追蹤',
  'pages.defectManagement.columns.id': '缺陷編號',
  'pages.defectManagement.columns.title': '缺陷描述',
  'pages.defectManagement.columns.severity': '嚴重級別',
  'pages.defectManagement.columns.owner': '責任團隊',
  'pages.defectManagement.columns.status': '狀態',
  'pages.defectManagement.columns.updatedAt': '更新時間',
  'pages.defectManagement.severity.critical': '嚴重',
  'pages.defectManagement.severity.major': '一般',
  'pages.defectManagement.severity.minor': '提示',
  'pages.defectManagement.status.open': '待修復',
  'pages.defectManagement.status.fixed': '待驗證',
  'pages.defectManagement.status.closed': '已關閉',
  'pages.defectManagement.mock.bug101.title': '訂單提交後偶發重複建立',
  'pages.defectManagement.mock.bug099.title': '需求文件匯出樣式錯位',
  'pages.defectManagement.mock.bug087.title': '通知中心未讀數刷新延遲',
  'pages.defectManagement.mock.backendTeam': '後端組',
  'pages.defectManagement.mock.frontendTeam': '前端組',
  'pages.defectManagement.mock.platformTeam': '平台組',
  'pages.defectManagement.status.new': '新建',
  'pages.defectManagement.status.assigned': '已分派',
  'pages.defectManagement.status.inProgress': '處理中',
  'pages.defectManagement.status.resolved': '待驗證',
  'pages.defectManagement.status.reopened': '已重開',
  'pages.defectManagement.columns.priority': '優先級',
  'pages.defectManagement.columns.assignee': '指派人',
  'pages.defectManagement.columns.action': '操作',
  'pages.defectManagement.columns.createdAt': '建立時間',
  'pages.defectManagement.action.create': '新建缺陷',
  'pages.defectManagement.action.edit': '編輯',
  'pages.defectManagement.action.view': '詳情',
  'pages.defectManagement.action.transition': '流轉',
  'pages.defectManagement.action.comment': '發表評論',
  'pages.defectManagement.detail.comments': '評論',
  'pages.defectManagement.detail.operations': '操作歷史',
  'pages.defectManagement.redirectTip':
    '來自測試管理入口，已切換到統一缺陷工作台',
  'auto.pages.pages.requirements.application-analysis.index.113':
    '請至少輸入一條端名稱（每行一條）',
  'auto.pages.pages.requirements.application-analysis.index.114':
    '已根據手動輸入生成 {p1} 條端預覽',
  'auto.pages.pages.requirements.application-analysis.index.115':
    '拆解模式：盡可能多（上限20）',
  'auto.pages.pages.requirements.application-analysis.index.116':
    '拆解模式：指定數量（{p1}）',
  'auto.pages.pages.requirements.application-analysis.index.117': '拆解模式',
  'auto.pages.pages.requirements.application-analysis.index.118': 'A、盡可能多',
  'auto.pages.pages.requirements.application-analysis.index.119': 'B、指定數量',
  'auto.pages.pages.requirements.application-analysis.index.120': 'C、人工錄入',
  'auto.pages.pages.requirements.application-analysis.index.121': '人工錄入',
  'auto.pages.pages.requirements.application-analysis.index.122':
    '請輸入人工端清單',
  'auto.pages.pages.requirements.application-analysis.index.123':
    '每行一條端名稱，僅填寫名稱即可',
  'auto.pages.pages.requirements.application-analysis.index.124':
    '例如：\nWeb管理端\niOS移動端\n小程序端',
  'auto.pages.pages.requirements.application-analysis.index.125':
    '可選：提供額外拆解指引，幫助AI更好理解需求',
  'auto.pages.pages.requirements.application-analysis.index.126':
    '項目資訊（可選）',
  'auto.pages.pages.requirements.application-analysis.index.127':
    '預覽人工錄入',
  'auto.pages.pages.requirements.application-analysis.index.128':
    '參考資料（可選）',
  'auto.pages.pages.requirements.application-analysis.index.129':
    '可貼上背景資料、約束說明、歷史案例，幫助 AI 更精準拆解',
  'auto.pages.pages.requirements.application-analysis.index.130':
    '例如：\n- 終端規範：管理端以 Web 優先，外勤以移動端優先\n- 對標案例：XX 系統採用 Web+App+小程序三端協同',
  'auto.pages.pages.requirements.application-analysis.index.131': '刪除',

  // Codebase detail drawer
  'pages.codebase.detail.title': '代碼庫詳情',
  'pages.codebase.detail.tab.token': '令牌設定',
  'pages.codebase.detail.tab.commits': '提交歷史',
  'pages.codebase.detail.tab.readme': 'README 預覽',
  'pages.codebase.detail.branch.placeholder': '選擇分支',
  'pages.codebase.detail.noProjectId': '請先配置 GitLab 專案 ID 以查看詳情',
  'pages.codebase.token.create': '建立令牌',
  'pages.codebase.token.name': '令牌名稱',
  'pages.codebase.token.scopes': '權限範圍',
  'pages.codebase.token.expiresAt': '過期時間',
  'pages.codebase.token.accessLevel': '存取級別',
  'pages.codebase.token.status': '狀態',
  'pages.codebase.token.active': '有效',
  'pages.codebase.token.revoked': '已撤銷',
  'pages.codebase.token.expired': '已過期',
  'pages.codebase.token.createdAt': '建立時間',
  'pages.codebase.token.createdSuccess': '令牌建立成功',
  'pages.codebase.token.createdWarning':
    '此令牌值僅顯示一次，請立即複製儲存。關閉後將無法再次查看。',
  'pages.codebase.token.empty': '暫無專案令牌',
  'pages.codebase.token.neverExpires': '永不過期',
  'pages.codebase.commit.hash': '提交雜湊',
  'pages.codebase.commit.message': '提交資訊',
  'pages.codebase.commit.author': '作者',
  'pages.codebase.commit.date': '提交日期',
  'pages.codebase.commit.stats': '變更統計',
  'pages.codebase.commit.empty': '暫無提交記錄',
  'pages.codebase.readme.empty': '當前分支未找到 README 檔案',
  'pages.codebase.readme.loading': '載入 README 中...',
  'pages.codebase.readme.error': '載入 README 失敗，請檢查 GitLab 設定',
  'pages.codebase.detail.viewDetail': '詳情',
};
